module.exports = __webpack_public_path__ + "media/img/frontend_application/landing-faq-2d1c25cb7db86c57c261f0566d748d61.png";